import { useEffect, useState } from "react";
import { api } from "../lib/api";

let cached = { offset: 0, at: 0 };

// Deriv server-clock offset (ms) measured by the backend (`time` call, RTT-corrected). Polled every 60s, shared across callers.
export function useDerivClock() {
  const [offset, setOffset] = useState(cached.offset);
  useEffect(() => {
    const load = () => api.get("/trading/telemetry").then(({ data }) => {
      if (data.clock_offset_ms != null) { cached = { offset: data.clock_offset_ms, at: Date.now() }; setOffset(data.clock_offset_ms); }
    }).catch(() => {});
    if (Date.now() - cached.at > 60000) load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  return offset;
}
